import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import BaseModal from 'components/atoms/base-modal';
import BaseButton from 'components/atoms/baseButton';
import { useTranslation } from 'react-i18next';
import BaseForm from 'components/atoms/base-form';
import { useFormik } from 'formik';
import BaseFormItem from 'components/atoms/base-form/item';
import BaseInput from 'components/atoms/base-input';

import { manualEnterCallSchema } from './validationSchema';

const ManualEnterCall = ({ isOpen, toggle, patientGuid, isRpmPanel }) => {
  const { t } = useTranslation();
  const {
    connect: { handleConnectPopoutOpen, connectDetails },
  } = useDispatch();

  const formik = useFormik({
    initialValues: { phoneNumber: '' },
    enableReinitialize: true,
    validationSchema: manualEnterCallSchema(),
    validateOnChange: true,
    onSubmit: ({ phoneNumber }) => {
      const details = {
        phone: phoneNumber,
        guid: patientGuid,
        isRpmCall: isRpmPanel,
      };
      connectDetails(details);
      handleConnectPopoutOpen(true);
      toggle();
    },
  });

  const { submitForm, resetForm, isValid, dirty, isSubmitting } = formik;

  const onCancel = () => {
    resetForm();
    toggle();
  };

  useEffect(() => {
    if (!isOpen) resetForm();
  }, [isOpen, resetForm]);

  return (
    <BaseModal
      title={t('labels.manualEnterCall')}
      open={isOpen}
      onCancel={onCancel}
      withFooter={[
        <BaseButton
          key="call"
          dataCy="manual-call-submit-button"
          label={t('controls.call')}
          onClick={submitForm}
          disabled={!(dirty && isValid) || isSubmitting}
          loading={isSubmitting}
        />,
      ]}
    >
      <BaseForm formik={formik} withControls plaintext={false} readonly={false}>
        <BaseFormItem
          name="phoneNumber"
          required
          label={t('labels.phoneNumber')}
          isBlackLabel
        >
          <BaseInput
            placeholder={t('placeholders.enterPhoneNumber')}
            allowClear
            maxLength={20}
            value={formik.values.phoneNumber}
            onChange={(value) => formik.setFieldValue('phoneNumber', value)}
            invalid={!!formik.errors.phoneNumber && formik.touched.phoneNumber}
          />
        </BaseFormItem>
      </BaseForm>
    </BaseModal>
  );
};

ManualEnterCall.defaultProps = {
  isOpen: false,
  isRpmPanel: false,
};

ManualEnterCall.propTypes = {
  toggle: PropTypes.func.isRequired,
  patientGuid: PropTypes.string.isRequired,
  isRpmPanel: PropTypes.bool,
  isOpen: PropTypes.bool,
};

export default ManualEnterCall;
